<template>
  <div class="CustomerService">
    <a :href="`${href}&clientId=${name}`" v-if="isShowZhangLogin">
      <img src="./../assets/img/kf.png" alt="" />
    </a>
    <a :href="tklUrl" v-else>
      <img src="./../assets/img/kf.png" alt="" />
    </a>
  </div>
</template>

<script>
export default {
  name: "CustomerService",
  components: {},
  data() {
    return {
      href: `https://other.youxuanmall.net/wapchat.html?accessId=69fc7120-36f2-11ec-970e-ab3ba8e9c772&fromUrl=https://www.youxuanmall.net&urlTitle=积分云&language=ZHCN&otherParams={%22peerId%22:%2210053430%22}`,
      includeMallZhang: ['tkl', 'srys'],
      tklUrl: 'https://ykf-weixin01.7moor.com/wapchat.html?accessId=e70f3f10-e10b-11ee-a418-7fb130eab131&fromUrl=http://www.fensaas.com&urlTitle=积分云中国银行&language=ZHCN&otherParams={"peerId":"10053430"}&wechatOrAppImplant=true'
    };
  },
  computed: {
    name() {
      return this.$store.state.userCount.account
    },
    isShowZhangLogin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      return !this.includeMallZhang.includes(malltype);
    }
  },
};
</script>

<style lang="less">
.CustomerService {
  position: fixed;
  bottom: 17%;
  right: 0.2rem;
  z-index: 9999;

  img {
    width: 1rem;
    height: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerService.vue